module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose--dark-24aed41197d9837a8f524a39163b967f.png";